const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact service",
  description: "Welcome to contact service",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Padangų prekybos komanda",
    car: "Automobilių salonų komanda",
    lkw: "Sunkvežimių komanda",
    em_otr: "EM/OTR komanda",
    farm_tractor: "Žemės ūkio traktorių komanda",
    bandag: "Bandag komanda",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
